export default __webpack_public_path__ + "static/media/Mark-3-Suit-03.486023a2.jpg";